<template>
  <div class="inspector-class-selection">
    <span v-for="selected in InspectorBus.selectClass"
          :key="selected.id"
          class="class-select"
          :class="selected.id"
          @click="handleClickClasses(selected)">
      <span class="select-check" :class="selected.isChecked ? `${selected.id} selected` : ''" />
      <span class="class-label">{{ selected.name }}</span>
    </span>
  </div>
</template>

<script>
import bus from '@/modules/report-inspector/report-inspector-scene/bus';
import InspectorBus from '../InspectorBus';

export default {
  name: 'ClassBar',
  data() {
    return {
      InspectorBus
    };
  },
  methods: {
    handleClickClasses(selectedClass) {
      const selected = selectedClass;
      selected.isChecked = !selectedClass.isChecked;

      this.$emit('classClicked', { selectedClass: selected, isChecked: selected.isChecked });

      if (selected.id === 'unrecognized') {
        bus.show_unrecognized_sku = !bus.show_unrecognized_sku;
        bus.toggleSkuByType();

        // change unrecognized legend
        const findUnrecognizeClassIndex = InspectorBus.skuLegends.findIndex(item => item.id === 'unrecognized');
        InspectorBus.skuLegends[findUnrecognizeClassIndex].isChecked = !InspectorBus.skuLegends[findUnrecognizeClassIndex].isChecked;
      }
    }
  }
};
</script>

<style lang="scss">
.inspector-class-selection {
  display: flex;

  .class-select {
    display: flex;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;

    .select-check {
      width: 13px;
      height: 13px;
      margin-right: 3px;
      border: 1px solid #535353;
      border-radius: 100px;

      &.selected {
        width: 10px;
        height: 10px;
      }

      &.sku {
        border: 3px solid #fcee22;
      }

      &.competitor_sku {
        border: 3px solid #c729ff;
      }

      &.price_tag {
        border: 3px solid #6efff1;
      }

      &.other_classes {
        border: 3px solid #8cc1ff;
      }

      &.unrecognized {
        border: 3px solid #777;
      }
    }

    .class-label {
      font-size: 13px;
      font-weight: 600;
      line-height: 17.7px;
      color: #535353;
    }

    @include breakpoint(lg-max) {
      margin-right: 4px;

      .select-check {
        width: 10px;
        height: 10px;

        &.selected {
          width: 8px;
          height: 8px;
        }
      }

      .class-label {
        font-size: 11px;
      }
    }
  }
}
</style>
